import React from 'react';
import {
  Public,
  CurrencyExchange,
  Language,
  CalendarToday,
  AccessTime,
  AccountBalance,
  Calculate,
  LocationOn,
  Category,
  ReceiptLong,
  PhoneIphone,
} from '@mui/icons-material';

export type ToolGroup = 'localization' | 'operations' | 'trade';

export interface ToolNavItem {
  text: string;
  path: string;
  icon: React.ReactElement;
  group: ToolGroup;
  isWip?: boolean;
}

export const toolNavItems: ToolNavItem[] = [
  { text: 'Country Details', path: '/details', icon: <Public fontSize="small" />, group: 'localization' },
  { text: 'Currency Conversion', path: '/currency', icon: <CurrencyExchange fontSize="small" />, group: 'operations' },
  { text: 'Language & Locale', path: '/language-locale', icon: <Language fontSize="small" />, group: 'localization' },
  { text: 'IP-to-Country & Geolocation', path: '/geolocation', icon: <LocationOn fontSize="small" />, group: 'trade' },
  { text: 'Unit & Size Converter', path: '/unit-converter', icon: <Calculate fontSize="small" />, group: 'operations' },
  { text: 'Holiday Calendar', path: '/holidays', icon: <CalendarToday fontSize="small" />, group: 'operations' },
  { text: 'Time Zone Converter', path: '/timezone', icon: <AccessTime fontSize="small" />, group: 'localization' },
  { text: 'IBAN/BIC Validator', path: '/iban', icon: <AccountBalance fontSize="small" />, group: 'trade' },
  { text: 'HS Code Search', path: '/hs-code', icon: <Category fontSize="small" />, group: 'trade' },
  { text: 'VAT / GST Calculator', path: '/vat-calculator', icon: <ReceiptLong fontSize="small" />, group: 'trade' },
  { text: 'Phone Number Generator', path: '/phone-number-generator', icon: <PhoneIphone fontSize="small" />, group: 'localization' },
];

export const toolPaths = toolNavItems.map((t) => t.path);

// Related tools for a page footer: same-group tools first, then fill from the
// rest in registry order, excluding the current page.
export const getRelatedTools = (currentPath: string, count = 3): ToolNavItem[] => {
  const current = toolNavItems.find((t) => t.path === currentPath);
  const others = toolNavItems.filter((t) => t.path !== currentPath);
  if (!current) return others.slice(0, count);
  const sameGroup = others.filter((t) => t.group === current.group);
  const rest = others.filter((t) => t.group !== current.group);
  return [...sameGroup, ...rest].slice(0, count);
};
